import React, { useState } from "react";
import { ChevronDown, Star } from "lucide-react";
import { useTranslation } from "react-i18next";

function Acc({ title, defaultOpen = false, testid, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-[#E5E5E5]">
      <button
        data-testid={testid}
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between py-4 text-left"
      >
        <span className="font-jost text-sm uppercase tracking-widest text-[#1A1A1A]">{title}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="pb-5 font-jost text-sm text-[#666] leading-relaxed">{children}</div>}
    </div>
  );
}

export function ProductAccordions({ p, reviews, out }) {
  const { t } = useTranslation();
  return (
    <div className="mt-8">
      <Acc title={t("detail.description")} defaultOpen testid="acc-description">
        {p.description ? p.description : t("detail.noDescription")}
      </Acc>
      <Acc title={t("detail.moreInfo")} testid="acc-infos">
        <ul className="space-y-1" data-testid="detail-attributes">
          {p.category && <li><span className="text-[#1A1A1A] font-medium">{t("detail.category")} :</span> {p.category}</li>}
          {Object.entries(p.attributes || {}).filter(([, v]) => v).map(([k, v]) => (
            <li key={k} data-testid={`detail-attr-${k}`}><span className="text-[#1A1A1A] font-medium capitalize">{k} :</span> {String(v)}</li>
          ))}
          <li>{t("detail.availability")} : {out ? t("detail.outOfStock") : t("detail.inStockN", { count: p.stock_qty })}</li>
          {p.weight_g > 0 && <li>{t("detail.weight")} : {p.weight_g} g</li>}
          {(p.length_cm > 0 || p.width_cm > 0 || p.height_cm > 0) && <li>{t("detail.dimensions")} : {p.length_cm} × {p.width_cm} × {p.height_cm} cm</li>}
        </ul>
      </Acc>
      <Acc title={`${t("detail.reviewsTitle")} ${reviews?.count ? `(${reviews.count})` : "(0)"}`} testid="acc-avis">
        {reviews?.count > 0 ? (
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <span className="font-serif-display text-2xl text-[#1A1A1A]">{reviews.average.toFixed(1)}</span>
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-3.5 w-3.5 ${Math.round(reviews.average) >= n ? "fill-[#1A1A1A] text-[#1A1A1A]" : "text-[#D9D9D9]"}`} />)}
              </div>
            </div>
            {(reviews.samples || []).map((r, i) => (
              <div key={r.created_at || `rev-${i}`} className="border-t border-[#F0F0F0] pt-2">
                <p className="text-[#1A1A1A] font-medium">{r.customer_name || t("store.customer")}</p>
                <p>« {r.comment} »</p>
              </div>
            ))}
          </div>
        ) : t("detail.noReviews")}
      </Acc>
    </div>
  );
}
